import React, { useEffect, useState } from 'react';
import { View, StyleSheet, Platform } from 'react-native';

import { Text } from '@/components/ui';
import { useIsLargeScreen } from '@/hooks/use-is-large-screen';
import { apiEnvironment } from '@/services/api-environment';
import { spacing } from '@/styles/theme';

export const EnvironmentBanner: React.FC = () => {
	const [isHydrated, setIsHydrated] = useState(Platform.OS !== 'web');
	const isLargeScreen = useIsLargeScreen();

	// Avoid SSR/hydration mismatches on web builds (pre-render can get out of sync with runtime bundle/env).
	useEffect(() => {
		setIsHydrated(true);
	}, []);

	if (!isHydrated) {
		return null;
	}

	if (!apiEnvironment.isPreview) {
		return null;
	}

	if (!isLargeScreen) {
		// Inline (non-absolute) stripe above the header so the preview marker
		// never overlaps the hamburger, search, or refresh controls.
		return (
			<View
				style={styles.mobileContainer}
				testID="environment-banner"
			>
				<Text style={styles.mobileTitle}>PREVIEW</Text>
			</View>
		);
	}

	return (
		<View
			style={styles.container}
			testID="environment-banner"
			// Hide on print
			{...({ dataSet: { printHide: '1' } } as any)}
		>
			<Text style={styles.title}>PREVIEW</Text>
		</View>
	);
};

export const EnvironmentBannerDetails: React.FC = () => {
	const [isHydrated, setIsHydrated] = useState(Platform.OS !== 'web');

	useEffect(() => {
		setIsHydrated(true);
	}, []);

	if (!isHydrated || !apiEnvironment.isPreview) {
		return null;
	}

	const apiLabel = apiEnvironment.apiHostname ? `API: ${apiEnvironment.apiHostname}` : `API: ${apiEnvironment.apiBaseUrl}`;

	return (
		<View style={styles.detailsContainer}>
			<Text style={styles.detailsTitle}>Preview Environment</Text>
			<Text style={styles.detailsSubtitle}>{apiLabel}</Text>
		</View>
	);
};

const styles = StyleSheet.create({
	container: {
		backgroundColor: '#F59E0B',
		paddingHorizontal: spacing.m,
		paddingVertical: 3,
		alignItems: 'center',
	},
	title: {
		fontSize: 11,
		fontWeight: '800',
		color: '#000',
		letterSpacing: 1,
	},
	mobileContainer: {
		backgroundColor: '#F59E0B',
		paddingVertical: 2,
		paddingHorizontal: spacing.m,
		alignItems: 'center',
		justifyContent: 'center',
	},
	mobileTitle: {
		fontSize: 11,
		fontWeight: '800',
		color: '#000',
		letterSpacing: 1,
	},
	detailsContainer: {
		backgroundColor: '#FEF3C7',
		paddingHorizontal: spacing.m,
		paddingVertical: spacing.s,
		borderRadius: 8,
		marginHorizontal: spacing.m,
		marginVertical: spacing.s,
	},
	detailsTitle: {
		fontSize: 13,
		fontWeight: '700',
		color: '#92400E',
	},
	detailsSubtitle: {
		fontSize: 11,
		color: '#92400E',
		marginTop: 2,
	},
});


